var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 33,
    viewBox: "0 0 40 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#DEEBFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(4 5)",
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.586 22.829C10.7717 23.0148 10.9922 23.1622 11.2349 23.2628C11.4776 23.3633 11.7378 23.4151 12.0005 23.4151C12.2632 23.4151 12.5233 23.3633 12.766 23.2628C13.0087 23.1622 13.2292 23.0148 13.415 22.829L10.585 20C10.3992 20.1857 10.2518 20.4062 10.1512 20.6489C10.0507 20.8917 9.9989 21.1518 9.9989 21.4145C9.9989 21.6772 10.0507 21.9374 10.1512 22.1801C10.2518 22.4228 10.3992 22.6433 10.585 22.829H10.586ZM15.384 10.478C15.8524 10.0088 16.4089 9.63663 17.0216 9.383C17.6342 9.12937 18.2909 8.99921 18.954 9C19.926 9 20.899 9.28 21.742 9.839C21.762 9.813 21.785 9.789 21.808 9.765C21.9043 9.66644 22.0197 9.58862 22.1472 9.53633C22.2747 9.48405 22.4116 9.45841 22.5493 9.46099C22.6871 9.46357 22.8229 9.49432 22.9484 9.55134C23.0738 9.60837 23.1863 9.69046 23.2788 9.79256C23.3713 9.89467 23.442 10.0146 23.4864 10.1451C23.5309 10.2755 23.5482 10.4137 23.5372 10.551C23.5263 10.6884 23.4873 10.8221 23.4228 10.9438C23.3583 11.0656 23.2695 11.1728 23.162 11.259C23.8046 12.2298 24.0919 13.3928 23.9752 14.5511C23.8586 15.7094 23.3452 16.7918 22.522 17.615L21.797 18.34C21.015 19.123 19.984 20.55 19.485 21.547L17.976 24.563C17.727 25.063 17.203 25.147 16.805 24.75L8.24897 16.195C7.85197 15.798 7.94097 15.271 8.43597 15.023L11.453 13.515C12.442 13.021 13.873 11.989 14.659 11.203L15.384 10.478V10.478ZM18.123 20.108C18.64 19.133 19.691 17.712 20.477 16.926L21.202 16.2C21.6984 15.7032 22.0081 15.0502 22.0786 14.3514C22.1491 13.6527 21.9762 12.951 21.589 12.365C21.399 12.079 20.871 11.599 20.73 11.505C20.2308 11.1748 19.6454 10.9992 19.047 11C18.6466 10.9994 18.25 11.0778 17.88 11.2309C17.51 11.384 17.1739 11.6087 16.891 11.892L15.941 12.843C15.157 13.628 13.722 14.663 12.74 15.154L11 16.024L17.07 22.093L18.123 20.108Z",
    fill: "#42526E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.b9009ec7.svg";
export { ForwardRef as ReactComponent };